export const skillsTypes = {
  GET_PLATFORM_DATA: 'skills/GETTING_DATA',
};

export const setSkills = (data) => ({
  type: skillsTypes.GET_PLATFORM_DATA,
  data,
});
